import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M13.513 11.188 9.619 7.294l1.069-1.045 2.825 2.825 5.675-5.65 1.044 1.045zM7.29 18.715l7.257 2.054 5.97-1.85a.86.86 0 0 0-.862-.704H14.76q-.655 0-1.113-.05a4.2 4.2 0 0 1-.94-.22l-2.258-.746.444-1.469 2.025.704q.454.154 1.048.21t1.69.07a1.2 1.2 0 0 0-.167-.64.83.83 0 0 0-.44-.363l-5.802-2.13-.053-.015a.3.3 0 0 0-.053-.005H7.29zm-5 2.923V12.06h6.84q.156 0 .317.033.16.032.3.082l5.828 2.147q.68.25 1.13.89t.45 1.502h2.5q1.077 0 1.755.695t.678 1.805v.807l-7.49 2.327-7.308-2.084v1.373zm1.5-1.5h2V13.56h-2z'
    />
  </svg>
)
export default SvgComponent
